import { Box, Alert } from "@mui/material";
import { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { createStudentSchema } from "../../schema/studentSchema";
import { mockStudentRegisterFields } from "../../data/mockStudentData";
import { createStudent } from "../../api/student";
import { getLocalStorageValue } from "../../utils/localStorage";
import AuthLayout from "../global/AuthLayout";
import FormFooter from "../shared/FormFooter";
import AuthForm from "../shared/AuthForm";

const initialValues = {
  firstName: "",
  lastName: "",
  email: "",
  password: "",
  phoneNumber: "",
  age: "",
  cnic: "",
  profilePicture: null,
  department: "",
  section: "",
};

const StudentRegister = () => {
  const [alertMessage, setAlertMessage] = useState("");
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const result = getLocalStorageValue("student");
    if (result) {
      navigate("/studentDashboard");
    }
  }, [navigate]);

  const handleFormSubmit = useCallback(async (values, { resetForm }) => {
    const formData = new FormData();
    formData.append("firstName", values.firstName);
    formData.append("lastName", values.lastName);
    formData.append("email", values.email);
    formData.append("password", values.password);
    formData.append("phoneNumber", values.phoneNumber);
    formData.append("age", values.age);
    formData.append("cnic", values.cnic);
    formData.append("department", values.department);
    formData.append("section", values.section);
    formData.append("profilePicture", values.profilePicture);

    try {
      await createStudent(formData);
      resetForm();
      navigate("/login");
    } catch (error) {
      setAlertMessage(error.response.data.msg);
      setShowAlert(true);
      setTimeout(() => {
        setShowAlert(false);
      }, 3000);
    }
  }, [navigate]);

  return (
    <AuthLayout title="Register Student">
      {/* Alert */}
      {showAlert && (
        <Box my={2}>
          <Alert variant="filled" severity="error">
            {alertMessage}
          </Alert>
        </Box>
      )}
      <AuthForm
        initialValues={initialValues}
        validationSchema={createStudentSchema}
        fields={mockStudentRegisterFields}
        onSubmit={handleFormSubmit}
      >
        <FormFooter
          text="If you already have an account"
          link="login"
          linkText="login"
          buttonText="Create New Student"
        />
      </AuthForm>
    </AuthLayout>
  );
};

export default StudentRegister;
